<template>
  <div id="conexaoCaixaVinculoAguardandoLogin">
    <div class="text-body2">
      Conclua o acesso na janela aberta no computador da lotérica.
    </div>
    <div class="text-caption text-grey-6 q-mt-xs">
      Sua senha não é enviada ao sistema.
    </div>

    <div class="row items-center justify-between q-mt-md">
      <q-btn
        flat dense no-caps
        color="grey-7"
        label="Começar de novo"
        @click="$emit('recomecar')"
      />
      <q-btn flat no-caps color="primary" label="Atualizar" @click="$emit('verificar')" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ConexaoCaixaVinculoAguardandoLogin",

  emits: ["recomecar", "verificar"],
};
</script>
